import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Spinner,
  Text,
  Textarea
} from '@chakra-ui/react';
import React, { ChangeEvent, ClipboardEvent, useEffect, useRef, useState } from 'react';
import './TransferForm.scss';
import { FirearmType } from '@/model/firearm-type.mjs';
import Transfer from '@/model/transfer.mjs';
import { LicenseById, createTransfer } from '@/api/apis.js';
import {
  setEZCheckForTransferCreationMessage,
  setEZCheckStatusTransferCreation,
  setIsEzCheckHistoryInprogress,
  setisTransferCreationAllowed,
  setSequalizeValidationError,
  setTotalTransfersCount,

} from '../ducks/slice';
import {
  getEightDigitLicenseKey,
  getPrimaryContact,
  getPrimaryValue
} from '@/explore/ffl-detail/utils.mjs';
// import { getBusinessDetailsEdited, getDefaultShippingAddressEdited } from '@/explore/ducks/selectors';
import ModalComponent from '@/common/Modal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { createTransferInitValue, formatPhoneNumber, maskLicense } from '@/utils/utils';
import { getFormattedDate } from '@/queue/elements/value-formatters/date-formatter.mjs';
import { DealerProfileType } from '@masterffl/dealer-profile-component';
import { callToEZCheckForTransferCreation } from '@/dealerProfile/ducks/slice';
import { useDispatch } from 'react-redux';
import { Toastertype, TransferDetailsType, TransferFormMode, TransferModalProps } from '@/dealerProfile/types';
import { getEzCheckErrorTransferCreation, getezCheckStatusTransferCreation, getIsEZCheckForTransferCreationInProgress, getSequalizeValidationError, getTotalTransfersCount, getIsTransferCreationAllowed } from '@/dealerProfile/ducks/selectors';
import { ezMessageMapping } from '@/model/Constants';
import { keyType } from '@/queue/types';
import { AxiosError } from 'axios';
import { OutlineToasterNotification } from '@/toaster/successNotification';
import { useNavigate } from 'react-router-dom';
import { createTransferValidation } from '@/dealerProfile/ducks/validationSchema';
import { optOutQueueMessage, TRANSFER_DETAILS } from '@/utils/constants';
import AriaSelectDropdown from '@/common/AriaSelectDropdown';
import { Key } from 'react-aria-components';
//@ts-ignore
import InputMask from 'react-input-mask';
import { getStoreData } from '@/redux/app-selectors';

interface TransferFormProps {
  dealerDetail: DealerProfileType;
  createTransfer: React.Dispatch<React.SetStateAction<Transfer>>;
  canCreatetransfer: React.Dispatch<React.SetStateAction<boolean>>;
  isSubmitting: boolean;
  formInitialData?: TransferDetailsType;
  mode?: TransferFormMode;
}

interface Errors {
  notes: string | null;
  buyerName: string | null;
  referenceId: string | null;
  storeURL: string | null;
  sku: string | null;
  buyerPhone: string | null;
  buyerEmail: string | null;
  modelType: string | null;
  street: string | null;
  city: string | null;
  state: string | null;
  zipCode: string | null;
}

interface TransferFormDetails extends Omit<Transfer, 'notes'> {
  notes: string;
}

export function TransferForm({
  dealerDetail: dealerDetails,
  createTransfer,
  canCreatetransfer,
  isSubmitting,
  formInitialData
}: TransferFormProps) {
  const [isLoading, setIsLoading] = useState(false);
  const [dealerDetail, setLicensee] = useState<DealerProfileType | undefined>(dealerDetails);

  const [licenseKey, setLicenseKey] = useState<string>(getEightDigitLicenseKey(dealerDetail?.primaryInboundDetails?.licenseKey ?? ""));
  // const [defaultShippingAddress, setDefaultShippingAddress] = useState<{address: { state: string; street: string; city: string; zipCode: string } | null, type: string}>({address: null, type: ""});
  const [formData, setFormData] = useState<TransferFormDetails>(
    createTransferInitValue
  );

  const [firearm, setFirearm] = useState<string>('');
  const [isBlacklisted, setIsBlacklisted] = useState<boolean>(false);

  const [isOptout, setIsOptout] = useState<boolean>(false);
  const [errors, setErrors] = useState<Errors>({
    notes: null,
    buyerName: null,
    referenceId: null,
    storeURL: null,
    sku: null,
    buyerEmail: null,
    buyerPhone: null,
    modelType: null,
    street: null,
    city: null,
    state: null,
    zipCode: null
  });
  // useEffect(() => {
  //   if (formInitialData && formInitialData.fflMasterDetails.licenseId) {
  //     setFirearm(
  //       formInitialData.TransferDetails.products &&
  //         formInitialData.TransferDetails.products.length > 0
  //         ? formInitialData.TransferDetails.products[0]
  //         : ''
  //     );
  //     setFormData({
  //       referenceId: formInitialData.TransferDetails?.orderId || '',
  //       buyerName: formInitialData.TransferDetails.buyer.name,
  //       notes:
  //         formInitialData.TransferDetails.notes &&
  //         formInitialData.TransferDetails.notes.length > 0
  //           ? formInitialData.TransferDetails.notes[0]
  //           : '',
  //       firearm:
  //         formInitialData.TransferDetails.products &&
  //         formInitialData.TransferDetails.products.length > 0
  //           ? formInitialData.TransferDetails.products[0]
  //           : '',
  //       orderDate: formInitialData.TransferDetails.orderDate
  //         ? new Date(formInitialData.TransferDetails.orderDate)
  //         : null,
  //       storeURL: formInitialData.TransferDetails.storeURL || '',
  //       buyerPhone: formInitialData.TransferDetails.buyer.phone,
  //       buyerEmail: formInitialData.TransferDetails.buyer.email,
  //       modelType: formInitialData.TransferDetails.modelType,
  //       street: formInitialData.TransferDetails.buyer.street || '',
  //       city: formInitialData.TransferDetails.buyer.city || '',
  //       state: formInitialData.TransferDetails.buyer.state || '',
  //       zipCode: formInitialData.TransferDetails.buyer.zipCode || '',
  //       key: licenseKey
  //     });
  //     setLicenseKey(
  //       getEightDigitLicenseKey(formInitialData.fflMasterDetails.licenseId)
  //     );
  //   }
  // }, [formInitialData]);

  const storeDetails = getStoreData()
  const isTransferCreationAllowed = getIsTransferCreationAllowed();
  const ezCheckStatus = getezCheckStatusTransferCreation();
  const ezCheckErrorMessage = getEzCheckErrorTransferCreation();
  const ezCheckForTransferCreationInProgress =
    getIsEZCheckForTransferCreationInProgress();
  const sequalizeValidationError = getSequalizeValidationError();
  const dispatch = useDispatch();
  const datePickerRef = useRef<any>(null);

  const openDatePicker = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setOpen(true);
    }
  };

  useEffect(() => {
    if(storeDetails) {
      setFormData((prevData: any) => ({
      ...prevData,
      storeURL: storeDetails?.store_domain?.replace(/\s+/g, '') ? `https://${storeDetails?.store_domain?.replace(/\s+/g, '')}` : ''
    }))
  }
  }, [storeDetails])

  // function setInitialValue() {
  //   setFirearm('');
  //   setFormData(createTransferInitValue);
  // }

  useEffect(() => {
    if (dealerDetails) {
      // setLicenseKey(
      //   `${
      //     dealerDetails.id[0] +
      //     dealerDetails.id.substring(2, 4) +
      //     dealerDetails.id.substring(dealerDetails.id.length - 5)
      //   }`
      // );
    }


    createTransfer({
      key: licenseKey,
      referenceId: formData.referenceId.trim(),
      firearm: firearm,
      buyerName: formData.buyerName ? formData.buyerName.trim() : '',
      notes: [formData.notes.trim()],
      orderDate: formData.orderDate,
      buyerEmail: formData.buyerEmail ? formData.buyerEmail.trim() : '',
      buyerPhone: formData.buyerPhone,
      sku: formData.sku ? formData.sku.trim() : '',
      storeURL: formData.storeURL ? formData.storeURL.trim() : '',
      modelType: formData.modelType ? formData.modelType.trim() : '',
      street: formData.street ? formData.street.trim() : '',
      city: formData.city ? formData.city.trim() : '',
      state: formData.state ? formData.state.trim() : '',
      zipCode: formData.zipCode ? formData.zipCode.trim() : ''
    });
    if (
      licenseKey &&
      firearm &&
      formData.buyerName &&
      formData.referenceId &&
      formData.buyerEmail &&
      formData.buyerPhone &&
      formData.modelType &&
      !errors.buyerName &&
      !errors.notes &&
      !errors.sku &&
      !errors.storeURL &&
      !errors.referenceId &&
      !errors.buyerEmail &&
      !errors.buyerPhone &&
      !errors.modelType &&
      !errors.street &&
      !errors.city &&
      !errors.state &&
      !errors.zipCode
    ) {
      canCreatetransfer(true);
    }
    else canCreatetransfer(false);
  }, [licenseKey, formData, firearm]);

  const isEZCheckCalled = useRef(false);
  useEffect(() => {
    if (
      (dealerDetails) &&
      !isEZCheckCalled.current &&
      licenseKey
    ) {
      dispatch(callToEZCheckForTransferCreation({ license_key: licenseKey }));
      // if (formInitialData) lookupLicensee();
      isEZCheckCalled.current = true;
    }
  }, [licenseKey, dealerDetails]);

  useEffect(() => {
    return () => {
      dispatch(setEZCheckStatusTransferCreation(null));
      dispatch(setisTransferCreationAllowed(false));
      dispatch(setIsEzCheckHistoryInprogress(false));
      dispatch(setEZCheckForTransferCreationMessage(null));
      dispatch(setSequalizeValidationError(null));
    };
  }, []);

  useEffect(() => {
    if (
      (!dealerDetail?.businessDetails.isOptOutForStore && !dealerDetail?.businessDetails.isOptInForStore) && dealerDetail?.businessDetails.isOptOutForAll
    ) {
      setIsOptout(true);
    }
    else if (dealerDetail?.businessDetails.isOptOutForStore) {
      setIsOptout(true)
    } else {
      setIsOptout(false);
    }
  }, [dealerDetail]);

  function renderLicenseId() {
    return <Box>{maskLicense(licenseKey)}</Box>
  }

  const validateField = async (name: string, value: string) => {
    try {
      await createTransferValidation.validateAt(name, { [name]: value });
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    } catch (error: any) {
      if (error.errors && error.errors.length > 0) {
        canCreatetransfer(false);
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: error.errors[0]
        }));
      }
    }
  };

  const onDateChange = (date: Date) => {
    setFormData((prevData: any) => ({
      ...prevData,
      orderDate: getFormattedDate(date)
    }));
  };

  const onPhoneAndPinChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputName = event.target.name;
    let inputVal = event.target.value;
    const regex = /^[0-9\b]+$/;
    let val = inputVal.replace(/\D/g, '');
    const maxLength = inputName === 'buyerPhone' ? 10 : 5;
    if (val === '' || regex.test(val)) {
      if (val.length >= maxLength) {
        val = val.slice(0, maxLength);
      }
      setFormData((prevData: any) => ({
        ...prevData,
        [inputName]: val
      }));
      if (val === '' || val.length === maxLength) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [inputName]: ''
        }));
      } else {
        validateField(inputName, val);
      }
    }
  };
  const handleContactNumberPaste = (event: ClipboardEvent<HTMLInputElement>): void => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData("text");
    const digitsOnly = pastedText.replace(/\D/g, "");
    if (digitsOnly) {
      setFormData((prevData: any) => ({
        ...prevData,
        buyerPhone: digitsOnly
      }));
    }
  };
  const onChangeInput = async (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const inputName = event.target.name;
    let inputVal = event.target.value;
    setFormData((prevData: any) => ({
      ...prevData,
      [inputName]: inputVal
    }));
    if (
      inputVal === ''
    ) {
      // setErrors((prevErrors) => ({
      //   ...prevErrors,
      //   [inputName]: ''
      // }));
    } else {
      validateField(inputName, inputVal);
    }
  };

  const phones = dealerDetails?.businessDetails.phones;
  const emails = dealerDetails?.businessDetails.emails;


  return (
    <Box className="transfer-form-wrapper transfer-form--create-modal">
      <form className="transfer-form">
        <div className="transfer-from__grid">
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              FFL License Number*:
            </FormLabel>
            <Box>
              {renderLicenseId()}
              {(!dealerDetails || ezCheckErrorMessage) && (
                <FormHelperText className="transfer-form__helper-text">
                  First 3, Last 5 of the FFL license number
                </FormHelperText>
              )}

              <Box className="ez-check-status failed">
                {ezCheckErrorMessage}
              </Box>
              {isBlacklisted && (
                <Box className="ez-check-status failed">
                  <img
                    className="ez-check-status__icon failed"
                    src="/images/ui/fail.svg"
                  />
                  This dealer is blacklisted.
                </Box>
              )}
              {isOptout && (
                <Box className="ez-check-status failed">
                  <img
                    className="ez-check-status__icon failed"
                    src="/images/ui/fail.svg"
                  />
                  {optOutQueueMessage[`${dealerDetail?.businessDetails.isOptOutForStore ? "store" : "all"}`]}
                </Box>
              )}
              {ezCheckForTransferCreationInProgress && (
                <div className="ez-check-status">
                  <Spinner size="sm" color="blue" />
                  EZ Check In-progress
                </div>
              )}
              {ezCheckStatus &&
                !ezCheckForTransferCreationInProgress &&
                ezMessageMapping[
                ezCheckStatus as keyType<typeof ezMessageMapping>
                ] && (
                  <div
                    className={`ez-check-status ${ezCheckStatus === '0' ? 'success' : 'failed'
                      }`}
                  >
                    {ezCheckStatus === '0' ? (
                      <div className="ez-check-status__icon success">
                        <img src="/images/ui/check-white.svg" />
                      </div>
                    ) : (
                      <img
                        className="ez-check-status__icon"
                        src="/images/ui/fail.svg"
                      />
                    )}
                    <span>
                      {
                        ezMessageMapping[
                        ezCheckStatus as keyType<typeof ezMessageMapping>
                        ]
                      }
                    </span>
                  </div>
                )}
            </Box>
          </FormControl>
          {
            <>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  License Information:
                </FormLabel>
                {(() => {
                  const primaryAddress = dealerDetail?.businessDetails?.address?.find(addr => addr?.isPrimary);
                  const premiseAddress = dealerDetail?.businessDetails?.address?.find(addr => addr?.type === 'premise');
                  const fallbackPremiseAddress = dealerDetail?.primaryInboundDetails?.premiseAddress;
                  
                  const addressToUse = primaryAddress || premiseAddress;
                  
                  return addressToUse ? (
                    <Box display="flex" flexDirection="column">
                      <Box className="transfer-form__license-info">
                        {dealerDetail?.primaryInboundDetails?.businessName}
                      </Box>
                      <Box className="transfer-form__license-info">
                        {addressToUse.address.street}
                      </Box>
                      <Box className="transfer-form__license-info">
                        {addressToUse.address.city},{" "}
                        {addressToUse.address.state}{" "}
                        {addressToUse.address.zipCode}
                      </Box>
                    </Box>
                  ) : fallbackPremiseAddress ? (
                    <Box display="flex" flexDirection="column">
                      <Box className="transfer-form__license-info">
                        {dealerDetail?.primaryInboundDetails?.businessName}
                      </Box>
                      <Box className="transfer-form__license-info">
                        {fallbackPremiseAddress.street}
                      </Box>
                      <Box className="transfer-form__license-info">
                        {fallbackPremiseAddress.city},{" "}
                        {fallbackPremiseAddress.state}{" "}
                        {fallbackPremiseAddress.zipCode}
                      </Box>
                    </Box>
                  ) : (
                    '-'
                  );
                })()}
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Email ID:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {emails && emails.length > 0 ? getPrimaryContact(emails) : '-'}
                  </Box>
                </Box>
              </FormControl>
              <FormControl className="transfer-form__item">
                <FormLabel className="transfer-form__label">
                  Phone number:
                </FormLabel>
                <Box display="flex" flexDirection="column">
                  <Box className="transfer-form__license-info">
                    {phones && phones.length > 0
                      ? formatPhoneNumber(getPrimaryContact(phones))
                      : '-'}
                  </Box>
                </Box>
              </FormControl>
            </>
          }
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Order ID*:</FormLabel>
            <Box display="flex" flexDirection="column">
              <Input
                type="text"
                isDisabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                onChange={onChangeInput}
                placeholder="Enter Order ID"
                name="referenceId"
                className="transfer-form__input"
                value={formData.referenceId}
              />
              <FormHelperText className="ez-check-status failed">
                {sequalizeValidationError}
              </FormHelperText>
              {errors.referenceId && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.referenceId}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Order Date:</FormLabel>
            <Box display="flex" flexDirection="column">
              <DatePicker
                selected={
                  formData.orderDate ? new Date(formData.orderDate) : null
                }
                showIcon
                name="date-input"
                dateFormat="MM-dd-yyyy"
                placeholderText="MM-DD-YYYY"
                className="transfer-form__input order-date-picker"
                onChange={(date: Date) => onDateChange(date)}
                ref={datePickerRef}
                disabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                icon={
                  <img
                    src="/images/ui/calendar-primary.svg"
                    onClick={openDatePicker}
                    style={{ cursor: 'pointer' }}
                    alt="calendar"
                  />
                }
              />
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">SKU:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.sku}
                  name="sku"
                  className="transfer-form__input"
                  placeholder="Enter SKU"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.sku && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.sku}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Store URL:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.storeURL}
                  name="storeURL"
                  className="transfer-form__input"
                  placeholder="Enter Store URL"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.storeURL && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.storeURL}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Buyer Name*:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.buyerName}
                  name="buyerName"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Name"
                />
              </Box>
              {errors.buyerName && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerName}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Phone Number*:
            </FormLabel>
            <Box>
              <Box>
                <InputMask
                  id="buyerPhone"
                  mask="999-999-9999"
                  className="transfer-form__input phone-mask-input"
                  value={formData.buyerPhone ?? ''}
                  name="buyerPhone"
                  placeholder="Enter Buyer Number"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onPhoneAndPinChange}
                  onPaste={handleContactNumberPaste}
                >
                  {(inputProps: any) => <input
                    {...inputProps}
                    type="text"
                    name="buyerPhone"
                    className="transfer-form__input phone-mask-input"
                  />
                  }
                </InputMask>
                {/* <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onPhoneAndPinChange}
                  value={formData.buyerPhone}
                  name="buyerPhone"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Number"
                /> */}
              </Box>
              {errors.buyerPhone && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerPhone}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Email*:
            </FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.buyerEmail}
                  name="buyerEmail"
                  className="transfer-form__input"
                  placeholder="Enter Buyer Email"
                />
              </Box>
              {errors.buyerEmail && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.buyerEmail}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">Model*:</FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.modelType}
                  name="modelType"
                  className="transfer-form__input"
                  placeholder="Enter Model"
                />
              </Box>
              {errors.modelType && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.modelType}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              Buyer Address:
            </FormLabel>
            <Box>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.street}
                  name="street"
                  className="transfer-form__input"
                  placeholder="Enter Street"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.street && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.street}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.state}
                  name="state"
                  className="transfer-form__input"
                  placeholder="Enter State"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.state && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.state}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  onChange={onChangeInput}
                  value={formData.city}
                  name="city"
                  className="transfer-form__input"
                  placeholder="Enter City"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                />
              </Box>
              {errors.city && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.city}
                  </Text>
                </Box>
              )}
            </Box>
            <Box marginTop={'10px'}>
              <Box>
                <Input
                  type="text"
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onPhoneAndPinChange}
                  value={formData.zipCode}
                  name="zipCode"
                  className="transfer-form__input"
                  placeholder="Enter Zip Code"
                />
              </Box>
              {errors.zipCode && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.zipCode}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
          <FormControl className="transfer-form__item">
            <FormLabel className="transfer-form__label">
              {TRANSFER_DETAILS.FIREARM_TYPE}*:
            </FormLabel>
            <Box  marginBottom={'10px'}>
              <AriaSelectDropdown
                aria-label="Firearm"
                onChangeDropdown={(value: Key) => setFirearm(value as string)}
                selectedOption={firearm}
                options={Object.entries(FirearmType)}
                variant="light"
                isDisabled={
                  isSubmitting ||
                  !isTransferCreationAllowed ||
                  isOptout ||
                  isBlacklisted
                }
                className="react-aria-Select react-aria-select-light"
                placeholder="-Select Firearm Type-"
              />
              {/* <Select
                isDisabled={
                  isSubmitting || !isTransferCreationAllowed || isOptout
                }
                onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                  setFirearm(e.target.value)
                }
                className={`transfer-form__input ${
                  !firearm && 'transfer-form__unselected'
                }`}
                placeholder="-Select Firearm Type-"
              >
                {Object.entries(FirearmType)
                  .map((entry, i) => (
                    <option key={i} value={entry[0]}>
                      {entry[1]}
                    </option>
                  ))}
              </Select> */}
            </Box>
            <FormLabel className="transfer-form__label">Notes:</FormLabel>
            <Box>
              <Box>
                <Textarea
                  isDisabled={
                    isSubmitting ||
                    !isTransferCreationAllowed ||
                    isOptout ||
                    isBlacklisted
                  }
                  onChange={onChangeInput}
                  value={formData.notes}
                  name="notes"
                  className="transfer-form__textarea"
                />
              </Box>

              {errors.notes && (
                <Box>
                  <Text as="sub" color="red">
                    {errors.notes}
                  </Text>
                </Box>
              )}
            </Box>
          </FormControl>
        </div>
      </form>
    </Box>
  );
}

export default function TransferModal({
  isOpen,
  onClose,
  dealerDetail,
  refetchData
}: TransferModalProps) {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [isCreatingTransfer, setIsCreatingTransfer] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  // const dispatch = useDispatch();
  const [createTransferValues, setCreateTransferValues] = useState<Transfer>({
    key: '',
    referenceId: '',
    firearm: '',
    status: '',
    buyerName: '',
    agent: '',
    notes: [''],
    orderDate: null,
    sku:'',
    storeURL: '',
    buyerPhone: '',
    buyerEmail: '',
    modelType: '',
    street: '',
    city: '',
    state: '',
    zipCode: ''
  });
  const totalTransferCount = getTotalTransfersCount();
  // const defaultShippingAddressEdited = getDefaultShippingAddressEdited();
  // const defaultShippingAddress = licensee ? (defaultShippingAddressEdited || licensee.defaultShippingAddress) : undefined;
  // const [query, setQuery] = useSearchParams();
  // const navigate = useNavigate();

  const handleModalAction = (response: Transfer | null) => {
    return () => {
      navigate(`/transfers/${response?.id}`);
    };
  };
  async function callCreateTransferApi() {
    setIsCreatingTransfer(true);

    try {
      const {
        street,
        city,
        state,
        zipCode,
        buyerPhone,
        buyerEmail,
        buyerName,
        key,
        referenceId,
        ...restCrateTransferPayload
      } = createTransferValues;
      const createTransferPayload = {
        licenseKey: key,
        orderId: referenceId,
        buyer: {
          street: street || '',
          city: city || '',
          state: state || '',
          zipCode: zipCode || '',
          phone: buyerPhone || '',
          email: buyerEmail || '',
          name: buyerName || ''
        },
        ...restCrateTransferPayload
      };
      const response: Transfer = await createTransfer(createTransferPayload);
      if (response) {
        dispatch(setTotalTransfersCount(totalTransferCount + 1));
        OutlineToasterNotification(
          Toastertype.success,
          `Great! Your transfer has been successfully created.`,
          handleModalAction(response)
        );
      }
      onClose();
      if (refetchData) {
        refetchData();
      }
    } catch (err) {
      const error = err as AxiosError<{ code: number }>;
      if (error?.response?.data?.code === 71)
        dispatch(
          setSequalizeValidationError(
            'Order ID already exists. Enter an unique ID'
          )
        );
      console.log(err);
    } finally {
      setIsCreatingTransfer(false);
      setDisabled(false);
    }
  }


  return (
    <ModalComponent
      title="Create a New Transfer"
      isOpen={isOpen}
      onClose={onClose}
      variant={2}
      modalType="createTransfer"
      footer={
        <>
          <Button
            colorScheme="blue"
            background="#ffffff"
            color="#0C1E46"
            border="1px solid #0C1E46"
            padding="8px 11px"
            marginRight="20px"
            isDisabled={isCreatingTransfer}
            onClick={() => {
              onClose();
              setDisabled(false);
            }}
          >
            Cancel
          </Button>
          <Button
            colorScheme="blue"
            background="#0C1E46"
            padding="8px 20px"
            onClick={callCreateTransferApi}
            isLoading={isCreatingTransfer}
            isDisabled={!disabled || isCreatingTransfer}
          >
            Save
          </Button>
        </>
      }
    >
      {dealerDetail &&
        <TransferForm
          dealerDetail={dealerDetail}

          createTransfer={setCreateTransferValues}
          canCreatetransfer={setDisabled}
          isSubmitting={isCreatingTransfer}
        />
      }
    </ModalComponent>
  );
}